import { query } from 'src/utils/request';
// 查询个人账户
// https://yapi.cai-inc.com/project/3075/interface/api/738066
export async function queryPersonAccount(data) {
  return query('/zlb/api/pay/jinkong/person/account/page', {
    method: 'POST',
    data,
  });
}

// 查询银行卡明文账户
// https://yapi.cai-inc.com/project/3075/interface/api/738058
export async function getByAccountCode(params) {
  return query('/zlb/api/pay/jinkong/person/account/get-by-accountCode', {
    method: 'GET',
    params,
  });
}

// 禁用个人账户
// https://yapi.cai-inc.com/project/3075/interface/api/738098
export async function disablePersonAccount(data) {
  return query('/zlb/api/pay/jinkong/person/account/disable', {
    method: 'POST',
    data,
  });
}

// 同步单位个人卡
// https://yapi.cai-inc.com/project/3075/interface/api/738050
export async function asyncPersonalCard(params) {
  return query('/zlb/api/pay/jinkong/person/account/sync', {
    method: 'GET',
    params,
  });
}

//  银行卡绑定
//  https://yapi.cai-inc.com/project/3075/interface/api/272914
export async function bindPersonalCard(data) {
  return query('/zlb/api/pay/jinkong/person/account/bind', {
    method: 'POST',
    data,
  });
}

//  银行卡解绑
//  https://yapi.cai-inc.com/project/3075/interface/api/749362
export async function unbindPersonalCard(data) {
  return query('/zlb/api/pay/jinkong/person/account/unbind', {
    method: 'POST',
    data,
  });
}
